import { Button, Col, Flex, Form, Image, Input, Row, Typography } from "antd";
import styled from "styled-components";
import resetPasswordBg from "../../../assets/reset-password-bg.png";

const { Title, Text } = Typography;
const { Password } = Input;
const { Item } = Form;

export const PageRow = styled(Row)`
  && {
    width: 100%;
    min-height: 100vh;
    margin: 0;
    background: linear-gradient(134deg, #ffffff 1%, #ffffff 100%);
    font-family: "Roboto", sans-serif;
    flex-wrap: nowrap;
  }

  @media (min-width: 992px) {
    && {
      position: fixed;
      inset: 0;
      height: 100vh;
      overflow: hidden;
    }
  }
`;

export const LeftCol = styled(Col)`
  && {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100vh;
    padding: 38px 0 38px 34px;
    box-sizing: border-box;
    overflow: hidden;
  }

  @media (max-width: 991px) {
    && {
      display: none;
    }
  }
`;

export const ImageCard = styled(Flex)`
  &&,
  &&:empty {
    display: block;
    width: 100%;
    height: 100%;
    background-image: url(${resetPasswordBg});
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    background-color: #d9d9d9;
    border-radius: 12px;
  }
`;

export const RightCol = styled(Col)`
  && {
    display: flex;
    align-items: flex-start;
    justify-content: center;
    min-height: 100vh;
    padding: 32px 20px;
    box-sizing: border-box;
  }

  @media (min-width: 992px) {
    && {
      height: 100vh;
      min-height: 0;
      padding: 64px 16px 16px;
      overflow: hidden;
    }
  }
`;

export const FormCard = styled(Flex)`
  width: 100%;
  max-width: 414px;

  @media (min-width: 992px) {
    max-height: 100vh;
  }
`;

export const BackButton = styled(Button)`
  && {
    width: 28px;
    height: 28px;
    min-width: 0;
    padding: 0;
    border: none;
    background: transparent;
    color: #28323e;
    box-shadow: none;
    outline: none;
    transition: none;
    margin-bottom: 12px;
    flex-shrink: 0;

    &:hover,
    &:focus,
    &:focus-visible,
    &:active {
      background: transparent !important;
      color: #28323e !important;
      border: none !important;
      box-shadow: none !important;
      outline: none !important;
    }

    &::after {
      display: none !important;
    }

    .anticon {
      font-size: 20px;
    }
  }
`;

export const LogoImage = styled(Image)`
  margin-bottom: 40px;

  @media (max-width: 575px) {
    margin-bottom: 24px;
  }
`;

export const StyledTitle = styled(Title)`
  && {
    font-family: "Roboto", sans-serif;
    font-size: 36px !important;
    font-weight: 700 !important;
    line-height: 48px !important;
    color: #28323e !important;
    text-align: left;
    margin: 0 0 16px !important;
    width: 100%;
  }

  @media (max-width: 575px) {
    && {
      font-size: 28px !important;
      line-height: 36px !important;
    }
  }
`;

export const SubtitleText = styled(Text)`
  && {
    display: block;
    width: 100%;
    font-family: "Roboto", sans-serif;
    font-size: 13px;
    font-weight: 400;
    line-height: 19px;
    color: rgba(40, 50, 62, 0.7);
    margin-bottom: 28px;
  }
`;

export const StyledForm = styled(Form)`
  width: 100%;

  .ant-form-item-label {
    padding-bottom: 6px;
  }

  .ant-form-item-label > label {
    font-family: "Roboto", sans-serif;
    font-size: 12px;
    font-weight: 600;
    line-height: 17px;
    color: #28323e;
    height: auto;
  }

  .ant-form-item {
    margin-bottom: 14px;
  }
`;

export const StyledPasswordInput = styled(Password)`
  && {
    height: 38px;
    border: 1px solid #d9d9d9;
    border-radius: 26px;
    background: #ffffff;
    padding: 0 19px;

    &:hover,
    &:focus-within {
      border-color: #4f78a1;
      box-shadow: none;
    }

    .ant-input {
      border: none;
      background: transparent;
      padding: 0;
      font-family: "Roboto", sans-serif;
      font-size: 12px;
      font-weight: 400;
      line-height: 17px;
      color: #28323e;

      &::placeholder {
        color: rgba(40, 50, 62, 0.6);
      }

      &:focus {
        box-shadow: none;
      }
    }

    .ant-input-suffix {
      color: #28323e;
    }
  }
`;

export const SubmitFormItem = styled(Item)`
  && {
    margin-bottom: 0;
    margin-top: 8px;
  }
`;

export const PrimaryButton = styled(Button)`
  && {
    margin-top: 8px;
    width: 100%;
    height: 47px;
    border-radius: 26px;
    background: #28323e;
    border: none;
    font-family: "Roboto", sans-serif;
    font-size: 14px;
    font-weight: 400;
    line-height: 22px;
    color: #ffffff;

    &:hover {
      background: #1c2530 !important;
      color: #ffffff !important;
    }
  }
`;
